import { Component, OnInit, ViewChild } from '@angular/core';

import {
  faFacebook,
  faFacebookF,
  faInstagram,
  faLinkedin,
  faLinkedinIn,
  faTwitter,
  faWhatsapp,
  faXTwitter,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
//import { ProductsComponent } from 'src/app/product/products/products.component';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  fb = faFacebookF;
  insta = faInstagram;
  linkedin = faLinkedinIn;
  twitter = faTwitter;
  whatsapp = faWhatsapp;
  youtube = faYoutube;
  faXtwitter = faXTwitter;
 // @ViewChild('productsComponent') productsComponent!:ProductsComponent

  constructor(){

  }
  ngOnInit(): void {
    
  }
  navTabChange(activeTab:any){
   // console.log(this.productsComponent)
  //  console.log(activeTab)
  }
}
